/* Imports */
import { API_HELPER } from "@/helpers/api.js";
import { authHeader } from "@/helpers/auth-header.js";
import { deepClone } from "@/helpers/utils.js";
import OliveOil from "@/classes/OliveOil";

/* Exports */
// API services that can be invoked on the modules
export const OLIVEOILS_SERVICE = {postOliveOil, getOliveOils, putOliveOil, getOliveOilDetails, deleteOliveOilById};

/* Consts*/
// Root service to build API url
const API_ROOT_SERVICE = "wines";

/* Services */
//Service to create oliveOils
function postOliveOil(input)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE]);

    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), "Content-Type":"application/json" },
        body: JSON.stringify(input)
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions);
}


//Service to get paginated oliveOils
function getOliveOils(queryParams)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE]);

    const requestOptions = {
        method: 'GET',
        headers: { ...authHeader() }
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, queryParams, requestOptions);
}


//Service to update oliveOils
function putOliveOil(input)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE]);

    // Review input to keep technical sheet if it was not removed
    var copy = deepClone(new OliveOil, input);
    Object.keys(copy.datasheets).forEach(function(key,index) {
        if (typeof copy.datasheets[key] === 'string' || copy.datasheets[key] instanceof String)
        {
            copy.datasheets[key] = {path: copy.datasheets[key]};
        }    
    });
    Object.keys(copy.nutritionalSheets).forEach(function(key,index) {
        if (typeof copy.nutritionalSheets[key] === 'string' || copy.nutritionalSheets[key] instanceof String)
        {
            copy.nutritionalSheets[key] = {path: copy.nutritionalSheets[key]};
        }    
    });

    const requestOptions = {
        method: 'PUT',
        headers: { ...authHeader(), "Content-Type":"application/json" },
        body: JSON.stringify(copy)
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions);
}


//Service to get oliveOil details
function getOliveOilDetails(uniqueIdentifier)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, uniqueIdentifier]);

    const requestOptions = {
        method: 'GET',
        headers: { ...authHeader() }
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions);
}


//Service to delete oliveOils
function deleteOliveOilById(id)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, id]);

    const requestOptions = {
        method: 'DELETE',
        headers: { ...authHeader() }
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions);
}
